<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-10 11:02:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/components/TitleBarBack/index.vue
-->
<template>
  <div class="bar">
    <div :class="{ bar_right_pad: !showBack }" class="search_bar">
      <img
        v-if="showBack"
        :class="{ mr_right: mrRight }"
        src="@/assets/common/icon_back@2x.png"
        alt=""
        class="search_go_back left"
        @click.stop="back"
      />
      <div class="right right_mr">
        <slot />
      </div>
      <div
        v-if="title"
        class="bar_title font18 font_weight500 line_height_48 text_center"
      >
        {{ title }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    showBack: {
      type: Boolean,
      default: true
    },
    mrRight: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    back() {
      this.$emit("back");
    }
  }
};
</script>

<style lang="less" scoped>
.bar {
  padding-top: 48px;
}
.bar_right_pad {
  padding: 0 12px 0 60px !important;
}
.search_bar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  z-index: 1999;
  background: #fff;
  // display: flex;
  // justify-content: space-between;
  // flex-direction: row;
  padding: 0 12px;
  box-shadow: 0px 3px 6px -3px rgba(193, 200, 207, 0.5);
  .search_go_back {
    width: 24px;
    cursor: pointer;
    margin: 10px 12px 0 0;
  }
}
.search {
  margin: auto 0;
  width: 100%;
}
.bar_title {
  margin: auto 0;
}
.right_mr {
  margin-top: 4px;
}
.cancel {
  margin: auto 0 auto 24px;
  font-size: 14px;
  font-weight: 400;
  color: #222;
  line-height: 48px;
}
.mr_right {
  margin: 10px 36px 0 0 !important;
}
</style>
